import { NgOptimizedImage } from '@angular/common';
import { Component, inject } from '@angular/core';
import { RouterLink } from '@angular/router';
import { LucideModule } from '../../../../../shared/modules/lucide.module';
import { Noticia } from '../../../models/noticia.model';
import { NoticiasService } from '../../../services/noticias.service';
import { DataNoticiaPipe } from '../../data-noticia.pipe';

@Component({
  selector: 'app-noticia-destaque',
  templateUrl: './noticia-destaque.component.html',
  styleUrls: ['./noticia-destaque.component.css'],
  imports: [NgOptimizedImage, RouterLink, LucideModule, DataNoticiaPipe],
})
export class NoticiaDestaqueComponent {
  private readonly noticiasService = inject(NoticiasService);

  readonly destaques = this.noticiasService.destaques().noticias;

  rota(noticia: Noticia): readonly string[] {
    return this.noticiasService.rota(noticia);
  }
}
